import { Grid, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import localisations from "../../../localisation";

type EnterCustomerSpecificDetailsStageProps = {
    fields: { customerFields: any };
    handleFieldChange: (fields: any) => void;
    onDisableNextButton: (disableNextButton: boolean) => void;
};

function EnterCustomerSpecificDetailsStage(props: EnterCustomerSpecificDetailsStageProps) {
    const { heading, blurb, wbsCodeLabel, aucCodeLabel, orderRaiserLabel, po1NumberLabel, po2NumberLabel } =
        localisations.createPreAlert.stages.enterCustomerSpecificDetails;

    const { onDisableNextButton } = props;

    const customerFields = props.fields.customerFields ?? {};

    const isPO2NumberValid = (): boolean => {
        return customerFields.po2Number !== undefined && customerFields.po2Number?.trim().length > 0;
    };

    const [po2IsValid, setPO2IsValid] = useState(isPO2NumberValid());
    const [showPO2Error, setShowPO2Error] = useState(false);

    useEffect(() => {
        onDisableNextButton?.(!po2IsValid);
    }, [po2IsValid, onDisableNextButton]);

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {heading}
            </Typography>

            <Typography variant="body1" gutterBottom>
                {blurb}
            </Typography>

            <Grid container>
                <Grid item xs={12}>
                    <TextField
                        id="pre-alert-wbs-field"
                        label={wbsCodeLabel}
                        style={{ margin: 8 }}
                        fullWidth
                        margin="normal"
                        value={customerFields.wbsCode ?? ""}
                        onChange={(event) => {
                            customerFields.wbsCode = event.target.value;
                            props.handleFieldChange({ customerFields });
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="pre-alert-auc-field"
                        label={aucCodeLabel}
                        style={{ margin: 8 }}
                        fullWidth
                        margin="normal"
                        value={customerFields.aucCode ?? ""}
                        onChange={(event) => {
                            customerFields.aucCode = event.target.value;
                            props.handleFieldChange({ customerFields });
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="pre-alert-orderRaiser-field"
                        label={orderRaiserLabel}
                        style={{ margin: 8 }}
                        fullWidth
                        margin="normal"
                        value={customerFields.orderRaiser ?? ""}
                        onChange={(event) => {
                            customerFields.orderRaiser = event.target.value;
                            props.handleFieldChange({ customerFields });
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="pre-alert-po1Number-field"
                        label={po1NumberLabel}
                        style={{ margin: 8 }}
                        fullWidth
                        margin="normal"
                        value={customerFields.poNumber ?? ""}
                        onChange={(event) => {
                            customerFields.poNumber = event.target.value;
                            props.handleFieldChange({ customerFields });
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="pre-alert-po2number-field"
                        required
                        autoComplete="off"
                        error={!po2IsValid && showPO2Error}
                        onBlur={() => {
                            setPO2IsValid(isPO2NumberValid());
                            setShowPO2Error(true);
                        }}
                        label={po2NumberLabel}
                        style={{ margin: 8 }}
                        fullWidth
                        margin="normal"
                        value={customerFields.po2Number ?? ""}
                        onChange={(event) => {
                            customerFields.po2Number = event.target.value;
                            setPO2IsValid(isPO2NumberValid());
                            props.handleFieldChange({ customerFields });
                        }}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export default EnterCustomerSpecificDetailsStage;
